module.exports = __webpack_public_path__ + "static/media/W.e09c9b00.svg";